import { getOrderCategories } from "./orderCategories";

const MAX_PICTURE_SIZE_BYTES = 5 * 1024 * 1024;
const ALLOWED_PICTURE_TYPES = ["image/jpeg", "image/png", "image/webp"];

export const validateOrder = (formData) => {
  const errors = {};

  if (!formData.name.trim()) {
    errors.name = "الاسم مطلوب";
  }

  if (!formData.phone.trim()) {
    errors.phone = "رقم الهاتف مطلوب";
  } 
  // 🔹 تحقق من وجود حروف
  else if (!/^\d+$/.test(formData.phone)) {
    errors.phone = "رقم الهاتف يجب أن يحتوي على أرقام فقط";
  } 
  // 🔹 تحقق من الصيغة الليبية
  else if (!/^09\d{8}$/.test(formData.phone)) {
    errors.phone = "رقم الهاتف غير صحيح (يجب أن يبدأ بـ 09 ويتكون من 10 أرقام)";
  }

  if (!formData.location.trim()) {
    errors.location = "الموقع مطلوب";
  }

  if (getOrderCategories(formData).length === 0) {
    errors.categories = "الرجاء اختيار صنف واحد على الأقل";
  }

  if ((formData.meters === "" || Number(formData.meters) === 0) && formData.status === "manufacturing") {
    errors.meters = "الرجاء ادخال عدد الأمتار";
  }

  const pictureFiles = Array.isArray(formData.pictureFiles) ? formData.pictureFiles : [];
  const invalidPicture = pictureFiles.find((file) => !ALLOWED_PICTURE_TYPES.includes(file.type));
  const oversizedPicture = pictureFiles.find((file) => file.size > MAX_PICTURE_SIZE_BYTES);

  if (invalidPicture) {
    errors.pictureFiles = "الصورة يجب أن تكون بصيغة JPG أو PNG أو WebP";
  } else if (oversizedPicture) {
    errors.pictureFiles = "حجم الصورة يجب ألا يتجاوز 5MB";
  }
  
  return errors;
};
